import { Routes } from '@/Routes';
import { IonApp, IonPage, setupIonicReact } from '@ionic/react';
import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
/* Theme variables */
import '@ionic/react/css/palettes/dark.system.css';
/* Theme variables */
import '@/theme/colors.css';
import '@/theme/globalstyles.css';
import '@/theme/variables.css';
import '@/theme/typography.css';
import '@/theme/swiper.css';
import '@/theme/pagination.css';
import '@/theme/floatingButton.css';

import { useEffect } from 'react';

import { AuthProvider } from '@/contexts/authContext';
import { LoadingProvider } from '@/contexts/LoadingContext';

import { Toaster } from './components/Toaster/Toaster';
import { loadThemeColors } from './theme/colors';

Sentry.init(
  {
    dsn: 'https://951306ce60b8998cec86b64a52a88350@o4509286562070528.ingest.de.sentry.io/4509286564495440',
    integrations: [SentryReact.replayIntegration(), SentryReact.browserTracingIntegration()],
    // Session replay configuration
    // ? We don't really wanna be tracing anything unless there is an error
    replaysSessionSampleRate: 0,
    // ? On errors we definitely want the full session replay to see what the user did
    replaysOnErrorSampleRate: 1.0,
    // General performance tracing
    // ? We set this to 5% but we might want to increase or decrease this later on
    tracesSampleRate: 0.05,
  },
  // Forward the init method from @sentry/react
  SentryReact.init,
);

setupIonicReact({
  mode: 'ios',
  innerHTMLTemplatesEnabled: true,
  scrollAssist: false,
});

const App: React.FC = () => {
  useEffect(() => {
    loadThemeColors(); // Load colors once at startup
  }, []);

  return (
    <LoadingProvider>
      <IonApp>
        <IonPage>
          <AuthProvider>
            <Routes />
          </AuthProvider>
          <Toaster />
        </IonPage>
      </IonApp>
    </LoadingProvider>
  );
};
// eslint-disable-next-line import/no-default-export
export default App;
